// composables/useCustomVideoPlayer.ts
import { ref, onBeforeUnmount } from 'vue';
import { updateVideoProgress } from "@/request/course";
import { formatDuration } from "../../utils/utils";

export function useCustomVideoPlayer(videoSelector = '#courseVideo', data) {
  const isPlay = ref(false)
  const lastTime = ref(0)
  const quickLastTime = ref(0)
  const video = ref(null)

  let timeTracker = null
  let videoReadyCheck = null

  const bindVideoEvents = () => {
    if (!video.value) return
    video.value.addEventListener('ended', onEnded)
    video.value.addEventListener('ratechange', onRateChange)
    video.value.addEventListener('canplay', onLoadedMetadata) // 监听元数据加载完成
    // startTimeTracking()
  }

  const waitForVideo = () => {
    videoReadyCheck = window.setInterval(() => {
      const el = document.querySelector(videoSelector)
      if (el) {
        video.value = el
        clearInterval(videoReadyCheck)
        bindVideoEvents()
      }
    }, 200)
  }

  const onVideoPlay = () => {
    isPlay.value = true
    if (!video.value) return

    const t = data.info?.watchTime || 0
    video.value.currentTime = data.info?.watchTime === data.info?.realTime ? 0 : t
    quickLastTime.value = video.value.currentTime

    setTimeout(() => {
      video.value?.play()
    }, 300)
  }

  // 元数据加载完成后启动时间追踪
  const onLoadedMetadata = () => {
    if (!video.value) return
    startTimeTracking()
  }

  const startTimeTracking = () => {
    stopTimeTracking()
    timeTracker = window.setInterval(() => {
      if (!video.value) return
      const currentTime = Math.floor(video.value.currentTime)
      data.duration = video.value.duration || 0; // 设置总时长
      data.currentTime = video.value.currentTime; 
      data.videoDuration = formatDuration(data.duration - (video.value.currentTime || 0))

      if (video.value.currentTime > quickLastTime.value + 2) {
        video.value.currentTime = quickLastTime.value
      } else {
        quickLastTime.value = video.value.currentTime
      }

      if (currentTime !== lastTime.value) {
        lastTime.value = currentTime
        updateVideoProgress({
          sec: currentTime,
          realTime: data.info.realTime,
          relId: data.info.relId
        })
      }
    }, 300)
  }

  const stopTimeTracking = () => {
    if (timeTracker) clearInterval(timeTracker)
  }

  const onRateChange = () => {
    if (video.value) video.value.playbackRate = 1.0
  }

  const onEnded = () => {
    isPlay.value = false
    data.isPlayFinish = true
    updateVideoProgress({
      sec: data.info.realTime,
      realTime: data.info.realTime,
      relId: data.info.relId
    })
  }

  const onFullScreen = () => {
    const videoBox = document.querySelector('.video-box')
    if (!document.fullscreenElement) {
      videoBox?.requestFullscreen?.()
      videoBox?.webkitRequestFullscreen?.()
      videoBox?.msRequestFullscreen?.()
    } else {
      document.exitFullscreen?.()
      document.webkitExitFullscreen?.()
      document.msExitFullscreen?.()
    }
  }

  // 主动触发检测
  waitForVideo()

  onBeforeUnmount(() => {
    stopTimeTracking()
    if (video.value) {
      video.value.removeEventListener('ended', onEnded)
      video.value.removeEventListener('ratechange', onRateChange)
    }
  })

  return {
    isPlay,
    video,
    onVideoPlay,
    onFullScreen,
    startTimeTracking,
    stopTimeTracking,
  }
}
